import { Image } from 'component/Image'
import { Space } from 'component/Space'
import { observer } from 'mobx-react-lite'
import { useDemo } from 'page/catalog/store/CatalogContext'
import { itemPreview } from 'page/catalog/store/ItemPreviewStore'
import css from './SingleImage.module.scss'

export const SingleImage = observer(() => {
  const { stand } = useDemo()
  const store = itemPreview.it
  const { images } = store
  const image = images[0]
  const round = stand ? 24 : 12

  return <Space className={css.pane} round={round} center>
    {image && <Image className={css.back} src={image} />}
    {image && <Image className={css.image} src={image} />}
  </Space>
})
